export const additionalDetailsPlaceholder=
    "Do not submit details on characteristics here. Changes to any attributes outside of Brand, Subcategory, and Category must be emailed to byzzer.support@smb.nielseniq.com.";
